export default __webpack_public_path__ + "static/media/FOTO10.6ad39b36.jpg";